import { useFieldArray } from "react-hook-form";
import { Hr } from "../../../../_components/Abstractions/Hr/Hr";
import { HorizontalView } from "../../../../_components/Abstractions/HorizontalView";
import { WeightDifferenceSelect } from "../../../contractors/Extensions/CreateContractor/WeightDifferenceSelect";
import { NumericControl } from "../../../../_components/Forms/NumericControl";
import { DomainButton } from "../../../../_components/Abstractions/DomainButton";
import { BiMinus } from "react-icons/bi";
import { PlusCircleFill } from "react-bootstrap-icons";
import { Card } from "react-bootstrap";

export function WeighbridgeTicketRejectedWasteDetailsForm({ ticketIndex }) {
  const fieldName = `weighbridgeTickets[${ticketIndex}].rejectedWastes`;
  const { fields, append, remove } = useFieldArray({ name: fieldName });
  const getFieldNameForItem = (idx, name) => `${fieldName}[${idx}].${name}`;

  return (
    <Card className="mt-2">
      <Card.Body>
        <Hr>Towary odrzucone</Hr>
        {fields.map((field, index) => (
          <HorizontalView key={field.id} columnsSize={[7, 4, 1]}>
            <WeightDifferenceSelect name={getFieldNameForItem(index, "weightDifference")} label="Różnica w wadze" saveWholeObject/>
            <NumericControl decimalPlaces={4} name={getFieldNameForItem(index, "wasteMass")} label="Masa [Mg]"/>
            <DomainButton className="mt-3" onClick={() => remove(index)}><BiMinus/></DomainButton>
          </HorizontalView>
        ))}
        <DomainButton size="small" onClick={() => append({})} className="mb-2">
          Odrzucony towar <PlusCircleFill/>
        </DomainButton>
      </Card.Body>
    </Card>
  );
}